import { Component, inject } from '@angular/core';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';
import { OrdersRow, SALESPERSON_PROFILE_LINK } from '../interface';
import { SALES_ORDERS_ACCESS_SERVICE_TOKEN } from '../sales-orders-table-access.service';
import { firstValueFrom, of } from 'rxjs';
import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'sales-ui-salesperson-cell',
  template: `
    <ng-container>
      <div class="title">
        @if (hasLinkAccess$ | async) {
          <a (click)="linkClicked(element)">
            <ng-container [ngTemplateOutlet]="salespersonDetails"></ng-container>
          </a>
        } @else {
          <ng-container [ngTemplateOutlet]="salespersonDetails"></ng-container>
        }
      </div>
      <div class="subtitle">{{ element.salesperson?.email }}</div>
    </ng-container>
    <ng-template #salespersonDetails>
      @if (element.salesperson?.firstName && element.salesperson?.lastName) {
        {{ element.salesperson?.firstName + ' ' + element.salesperson?.lastName }}
      } @else if (element.salesperson?.firstName) {
        {{ element.salesperson?.firstName }}
      } @else if (element.salesperson?.lastName) {
        {{ element.salesperson?.lastName }}
      }
    </ng-template>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        min-width: 0;
        max-width: 100%;
      }

      .title {
        font-size: 14px;
        font-weight: 500;
      }

      .subtitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.54);
      }
    `,
  ],
  standalone: false,
})
export class SalespersonCellComponent extends SalesOrderTableCustomComponentDirective {
  private readonly accessService = inject(SALES_ORDERS_ACCESS_SERVICE_TOKEN, { optional: true });
  protected readonly hasLinkAccess$ = this.accessService.orderTableSalespersonLinkAccess$
    ? this.accessService.orderTableSalespersonLinkAccess$
    : of(false);

  protected readonly salespersonLink = inject(SALESPERSON_PROFILE_LINK);
  private readonly router = inject(Router);
  private readonly snackbarService = inject(SnackbarService);

  protected async linkClicked(order: OrdersRow): Promise<void> {
    const hasAccess = await firstValueFrom(this.hasLinkAccess$);
    if (hasAccess) {
      this.router.navigateByUrl(this.salespersonLink(order));
    } else {
      this.snackbarService.openErrorSnack('FRONTEND.SALES_UI.ERRORS.ERROR_PERMISSION_DENIED');
    }
  }
}
